import { render, staticRenderFns } from "./homeCard.vue?vue&type=template&id=2baa5204&scoped=true&"
import script from "./homeCard.vue?vue&type=script&lang=js&"
export * from "./homeCard.vue?vue&type=script&lang=js&"
import style0 from "./homeCard.vue?vue&type=style&index=0&id=2baa5204&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baa5204",
  null
  
)

export default component.exports